'use strict';

var trackingUtils = require('../../modules/utils/tracking.utils');
module.exports = Odigeo.View.extend({
    events: {
        'tap @deepLink': 'onDeepLinkClick',
        'tap @shareButtonEmail': 'onShareButtonClick',
        'tap @shareButtonTracking': 'onShareButtonTracking',
    },

    selectors: {
        inputWrapper: '.share_flight_wrapper',
        deepLink: '.share_input_deeplink',
        tooltip: '.share_tooltip',
        shareButtonEmail: '.share_button_email',
        shareButtonTracking: '.share_button_tracking',
        inputLink: '.input_link',
    },

    tooltipTimeout: 2000,

    init: function() {
        var search = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
        if (Odigeo._.isObject(search) && Odigeo._.includes(['oneWayTrip', 'roundTrip'], search.type)) {
            this.widget.options = Odigeo.parseOptions(this.widget.options);
            this.renderTemplates();
            this.updateDomSelectorsToCache();
        }
    },

    renderTemplates: function() {
        this.model.searchdataPromise.then(() => {
            this.$el.find(this.selectors.inputWrapper).html(this.templates.inputLink(this.getTemplateScope()));
            if (Odigeo._.isFunction(this.templates.inputField)) {
                this.$el.find(this.selectors.inputLink).html(this.templates.inputField(this.getTemplateScope()));
            }
            this.$el.find(this.selectors.inputWrapper).addClass('loaded');
        });
    },

    toggleTooltip: function(toggle) {
        this.$el.find(this.selectors.tooltip).toggleClass('active', toggle);
    },

    onDeepLinkClick: function() {
        Odigeo.Utils.copyToClipboard(this.$el.find(this.selectors.deepLink));
        this.showTooltip();
        trackingUtils.trackEvent('share_flight', 'copy_click');
    },

    onShareButtonTracking: function(evt) {
        trackingUtils.trackEvent('share_flight', $(evt.currentTarget).data('trackingButton'), null, true);
    },

    onShareButtonClick: function(evt) {
        Odigeo.trigger(this.widget.id + ':onShareEmailSearch', evt, this.getEmailTemplateParams());
    },

    showTooltip: function() {
        this.toggleTooltip(true);
        Odigeo._.delay(Odigeo._.bind(this.toggleTooltip, this, false), this.tooltipTimeout);
    },

    plurarizeKeys: function(keys) {
        var search = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
        keys.shareTitle = Odigeo.Utils.pluralizeAll(keys.shareTitle, search.searchSegments.length);
        keys.emailTitleText = Odigeo.Utils.replaceCmsKeyArgs(keys.emailTitleText, 'sender_email_text', search.searchSegments.length);
        keys.emailTitleText = Odigeo.Utils.pluralizeAll(keys.emailTitleText, search.searchSegments.length);
        return keys;
    },

    parsePriceToTemplate: function(price) {
        var priceObj = Odigeo.Utils.splitFormatedCurrency(price);
        Odigeo._.forEach(['sufix', 'prefix'], function(value) {
            priceObj[value] = priceObj[value] ? Odigeo.Utils.encodeToHtmlEntity(priceObj[value]) : '';
        });
        return priceObj;
    },

    parseSearchParamsToTemplate: function(searchParams) {
        Odigeo._.forEach(searchParams.searchSegments, function(value) {
            value.dateStr = Odigeo.Utils.formatDate(value.dateStr, Odigeo.Utils.formatDate.masks.datepicker);
        });
        return searchParams;
    },

    checkDefaultName: function() {
        const passenger = Odigeo.Utils.parseJson(Odigeo.Session.get('passengersData'));
        return Odigeo._.isObject(passenger) && Odigeo._.isObject(passenger.passengers0) ? passenger.passengers0.name : '';
    },

    getEmailTemplateParams: function() {
        return {
            templateId: 'share.deeplink',
            defaultPassenger: this.checkDefaultName(),
            emailTemplateParams: Odigeo._.extend(this.keys, {
                link: this.model.get(this.model.get('linkType')),
                price: this.parsePriceToTemplate(this.widget.options.price),
                searchParams: this.parseSearchParamsToTemplate(Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'))),
            }),
        };
    },

    getTemplateScope: function() {
        return {
            link: this.model.get(this.model.get('linkType')),
            whatsappLink: this.model.get('shareLinkWhatsapp'),
            keys: this.plurarizeKeys(this.keys),
        };
    },
});
